import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
// Redux Imports
import { logoutUser, changeAcademicSession } from '../../actions/loginActions';
import { useDispatch, useSelector } from 'react-redux';
// Material Imports
import {
  Grid,
  Button,
  ClickAwayListener,
  Paper,
  Popper,
  MenuItem,
  MenuList,
  Avatar,
  makeStyles,
  ListItemText,
  Drawer,
  ListItem,
  List,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@material-ui/core';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import { Link } from 'react-router-dom';
//Components
import PopUpModal from '../PopUpModal';
import MyProfilePopup from './component/MyProfilePopup';
import Navigation from '../Navigation';
//Images
import Logo from '../../assets/logo.svg';
// Assets
import MenuToggle from './../../assets/toggle-icon.svg';
import MenuToggleBlack from './../../assets/toggle-icon-black.svg';
import image from './../../assets/image26.png';
import FaceBookIcon from '../../assets/socialIcon/facebook.svg';
import TwitterIcon from '../../assets/socialIcon/twitter.svg';
import linkedinIcon from '../../assets/socialIcon/linkedin.svg';
import InstagramIcon from '../../assets/socialIcon/instagram.svg';
import AppleStoreCode from './../../assets/Allen-Digital-AppleStore.png';
import GooglePlayStoreCode from './../../assets/AllenDigital-GooglePlayStore.png';
import AppleStoreImage from './../../assets/app-store.png';
import GooglePlayStoreImage from './../../assets/google-playstore.png';
import ProfileIcon from './../../assets/profileIcon/icon01.svg';
import LogoutIcon from './../../assets/profileIcon/icon03.svg';
import CheckIcon from '@material-ui/icons/Check';

//style
import '../DataTextCard/styles.scss';
//styles used in  PopUp
const useStyles = makeStyles(theme => ({
  dialogCustomizedWidth: {
    [theme.breakpoints.up('xs')]: {
      'max-width': '100%'
    },
    [theme.breakpoints.up('sm')]: {
      'max-width': '80%'
    },
    [theme.breakpoints.up('md')]: {
      'max-width': '30%'
    },
    [theme.breakpoints.up('xl')]: {
      'max-width': '25%'
    }
  },
  dialogPosition: {
    position: 'absolute',
    right: '0px',
    top: '0px'
  }
}));

export default function Layout(props) {
  const classes = useStyles();
  // Ref
  const childRef = useRef();
  const childRef_academic = useRef();
  const anchorRef = React.useRef(null);
  // State
  const [open, setOpen] = React.useState(false);
  const [openNav, setOpenNav] = React.useState(false);
  const [openOldWeb, setOpenOldWeb] = React.useState(false);
  // Redux
  const dispatch = useDispatch();
  //const jwt = useSelector((state) => get(state, 'loginReducer.data.jwt', ''));
  const loginData = useSelector(state => get(state, 'loginReducer.data', {}));
  const currentSession = useSelector(state =>
    get(state, 'loginReducer.data.profile[0].SessionName', '')
  );

  const profile = useSelector(state =>
    get(state, 'dashboardReducer.profileData', '')
  );
  const ProfilePhoto = get(profile, 'profile[0].StudentPic', '');

  // Functions
  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  const openDrawer = () => {
    setOpenNav(true);
  };
  const closeDrawer = () => {
    setOpenNav(false);
  };
  const handleClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }
    if (prevOpen.current === true && openNav === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = open;
    prevOpen.current = openNav;
  }, [open, openNav]);

  //user name
  const userName = get(profile, 'profile[0].FirstName', '');
  //application Number
  const applicationFormNo = get(profile, 'profile[0].EnrolmentNo', '');

  const academicSessionBody = () => {
    const list = [];
    if (loginData.academicSession)
      loginData.academicSession.map((item, index) => {
        return list.push(
          <ListItem
            key={index}
            button
            onClick={() => {
              changeAcademicSession(
                item.AcademicSessionID,
                loginData.jwt,
                dispatch
              );
            }}
          >
            <ListItemText
              className={
                currentSession === item.AcademicSessionName && 'selected'
              }
              primary={`Academic Session ${item.AcademicSessionName}`}
            />
            {currentSession === item.AcademicSessionName && <CheckIcon />}
          </ListItem>
        );
      });
    return <List className="list-content"> {list} </List>;
  };
  const academicSessionHeader = () => {
    return <div>Academic Sessions</div>;
  };
  const cs = loginData.academicSession
    ? loginData.academicSession[0].AcademicSessionName
    : null;
  return (
    <React.Fragment>
      <div className="flex-column body-wrapper">
        <div className=" flex-row align-center header ">
          <Grid container>
            <Grid>
              <div onClick={openDrawer} className="menu-toggle">
                <img src={MenuToggle} />
              </div>
              <Drawer
                anchor="left"
                open={openNav}
                className="navigation-drawer"
                onClose={closeDrawer}
              >
                <div
                  className="flex-column justify-center"
                  onClick={closeDrawer}
                  onKeyDown={closeDrawer}
                >
                  <div className=" flex-row align-center drawer-header">
                    <span onClick={closeDrawer} className="menu-toggle">
                      <img src={MenuToggleBlack} />
                    </span>
                    <div className="logo-brand inner">
                      <Link to="/" title="Allen Digital">
                        <img src={Logo} alt="logo" />
                      </Link>
                    </div>
                  </div>
                  <Button
                    color="secondary"
                    style={{ borderTop: '1px solid #ececec' }}
                    onClick={() => setOpenOldWeb(true)}
                  >
                    Go to Legacy Website
                  </Button>
                  <div className="dropdown-navigation navigation-layout">
                    <Navigation disableHoverListener={true} />
                  </div>
                </div>
              </Drawer>
            </Grid>
            <Grid>
              <div className="logo-brand inner">
                <Link to="/" title="Allen Digital">
                  <img src={Logo} alt="logo" />
                </Link>
              </div>
            </Grid>
            <Grid className="ml-auto">
              <Button
                ref={anchorRef}
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                onClick={handleToggle}
                className="profile-dropdown profile-button"
              >
                <Avatar
                  alt={userName}
                  src={ProfilePhoto}
                  className="small mr-10"
                />
                <span className="name">{userName}</span>
                <span className="caret"></span>
              </Button>
              <Popper
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
                placement="bottom-end"
              >
                <Paper>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList
                      autoFocusItem={open}
                      id="menu-list-grow"
                      onKeyDown={handleListKeyDown}
                      className="profile-dropdown"
                    >
                      <div className="profile-header">
                        <Avatar alt={userName} src={ProfilePhoto} />
                        <ListItemText
                          primary={userName}
                          secondary={`Application No. ${applicationFormNo}`}
                        />
                      </div>
                      <ListItem
                        button={
                          loginData.academicSession &&
                          loginData.academicSession[1]
                            ? true
                            : false
                        }
                        className="session"
                        onClick={() => {
                          if (
                            loginData.academicSession &&
                            loginData.academicSession[1]
                          )
                            childRef_academic.current.handleClickOpen();
                        }}
                      >
                        {(currentSession &&
                          `Academic Session ${currentSession}`) ||
                          (cs && `Academic Session ${cs}`) ||
                          'Academic Session -'}

                        {loginData.academicSession &&
                          loginData.academicSession[1] && (
                            <KeyboardArrowRightIcon />
                          )}
                      </ListItem>
                      <MenuItem
                        onClick={() => {
                          childRef.current.handleClickOpen();
                        }}
                      >
                        <span className="icon">
                          <img src={ProfileIcon} />
                        </span>
                        My Profile
                      </MenuItem>
                      <MenuItem
                        onClick={e => {
                          handleClose(e);
                          logoutUser(loginData.jwt, dispatch);
                        }}
                      >
                        <span className="icon">
                          <img src={LogoutIcon} />
                        </span>
                        Logout
                      </MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Popper>
            </Grid>
          </Grid>
        </div>
        <div className="main-wrapper">
          {props.banner ? (
            <img className="inner-banner" src={image} alt="sliderImage" />
          ) : (
            ''
          )}
          <div className={props.homepage ? 'page-wrapper' : 'inner-wrapper'}>
            {props.component}
          </div>
        </div>
        <div className="footer flex-row">
          <Grid container>
            <Grid item xs={12} sm={6} md={4}>
              <h3>Contact Us</h3>
              <address className="address">
                ALLEN Career Institute <br />
                &quot;SANKALP&quot; CP-6, <br />
                Indra Vihar Kota (Rajasthan), <br />
                India 324005 Phone: +91-744-2757575
              </address>
            </Grid>
            {/* <Grid item xs={12} sm={6} md={3}>
              <h3>Quick links</h3>
              <ul className="quick-links">
                <li>
                  <a href="">About Us</a>
                </li>
                <li>
                  <a href="">Privacy Policy</a>
                </li>
                <li>
                  <a href="">Terms & Condition</a>
                </li>
                <li>
                  <a href="">Gallery</a>
                </li>
              </ul>
            </Grid> */}
            <Grid item xs={12} sm={6} md={4}>
              <h3>Follow Us on</h3>
              <ul className="social-links">
                <li>
                  <a
                    href="https://www.facebook.com/ALLENKota/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={FaceBookIcon} alt="Facebook" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://twitter.com/allenkota"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/school/allen-career-institute/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={linkedinIcon} alt="Linkedin" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/allen_career_institute/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={InstagramIcon} alt="Instagram" />
                  </a>
                </li>
              </ul>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <h3>Download Our App</h3>
              <ul className="qr-icon">
                <li>
                  <a
                    href="https://apps.apple.com/in/app/allen-digital/id1512922338#?platform=iphone"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={AppleStoreCode} className="code" />
                    <img src={AppleStoreImage} className="icon" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://play.google.com/store/apps/details?id=app.allendigital.in"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={GooglePlayStoreCode} className="code" />
                    <img src={GooglePlayStoreImage} className="icon" />
                  </a>
                </li>
              </ul>
            </Grid>
            <Grid item xs={12}>
              <div className="copyright">
                <p>
                  Copyright @ 2020 ALLEN Career Institute. All Rights Reserved.
                </p>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
      <PopUpModal
        ref={childRef}
        header={MyProfilePopup().props.children[0]}
        body={MyProfilePopup().props.children[1]}
        fullScreen={true}
        width={classes.dialogCustomizedWidth}
        position={classes.dialogPosition}
        className="profile-popup"
      />

      <PopUpModal
        ref={childRef_academic}
        header={academicSessionHeader()}
        body={academicSessionBody()}
        fullScreen={true}
        width={classes.dialogCustomizedWidth}
        position={classes.dialogPosition}
        className="academic-session-popup"
      />

      <Dialog
        open={openOldWeb}
        onClose={() => setOpenOldWeb(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Redirect?</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Do you want to redirect on older version of this website.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenOldWeb(false)} color="primary">
            No, keep me here
          </Button>
          <Button
            onClick={() =>
              window.open(
                `https://student.allendigital.in/gateway?jwt=${loginData.jwt}`,
                '_self'
              )
            }
            color="secondary"
            autoFocus
          >
            Yes, I want
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
Layout.propTypes = {
  component: PropTypes.element.isRequired,
  banner: PropTypes.bool,
  homepage: PropTypes.bool
};

Layout.defaultProps = {
  banner: false,
  homepage: false
};
